module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('glogo'), _vm._v(" "), _c('grednav'), _vm._v(" "), _c('div', {
    staticClass: "row-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "project-sort pull-left"
  }, [_c('lnav', {
    ref: "lnav",
    on: {
      "filtrate": _vm.showCondition
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "notice-content pull-right"
  }, [_c('showtable', {
    ref: "showtable",
    attrs: {
      "captionTitle": _vm.captionTitle,
      "condition": _vm.checked,
      "dataUrl": _vm.tableDataUrl
    }
  })], 1)])]), _vm._v(" "), _c('gsupplier'), _vm._v(" "), _c('gfooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-182c4a76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/logistics/logistics.vue
// module id = 259
// module chunks = 7